module.exports = __webpack_public_path__ + "img/logo-sungevity-engie-color.0808bb6a.svg";